<template>
  <div class="test">
    <p class="explainer" v-translate v-for="item in explainer" data-po-exclude="true">{{ item }}</p>
    <a href="#" class="btn btn-primary btn-lg start-tests"
       v-bind:class="{ 'btn-success': pass, 'btn-danger': fail, 'btn-warning': skip }"
        v-on:click="doTest">
      <translate v-if="pass">Test Passed!</translate>
      <translate v-else-if="fail" >Test Failed</translate>
      <translate v-else-if="skip" >Test Skipped</translate>
      <translate v-else data-po-exclude="true">{{ callToAction.text }}</translate>
    </a>
  </div>
</template>

<script>
  /**
  * Contains a detailed explanation of the test that is about to take place
  * A button to start the test
  * The button will change color to green if the test passes, red if it fails
  */
  export default {

    name: 'Question',
    props: {
      /** * Array - An array of strings to be displayed explaining what the test is for */
      'explainer': {
        'type': Array
      },
      /** Object ({text: ''}) - Contains a text value to be displayed in the button and a url to navigate to
       * *NB. url attribute has been deprecated* */
      'callToAction': {
        'type': Object,
        'default': function () {
          return {text: ''}
        }
      },
      /**  Boolean - True if the test if and only if the test has passed.
      * Used to add a success class to the button */
      'pass': {
        'type': Boolean,
        'default': false
      },
      /**  Boolean - True if the test if and only if the test has passed.
      * Used to add a danger class to the button */
      'fail': {
        'type': Boolean,
        'default': false
      },

      'skip': {
        'type': Boolean,
        'default': false
      }
    },
    methods: {
      /**  Event handler for the click event in the button.  Stops the default action (navigating to the link).  Emits a custom event 'showBrowserDetails' for the parent component to handle
      * @public
      * @param {Event} e - The 'click' event passed from the 'a' tag in the component
      * @returns {Boolean} false - Always returns false to avoid unwanted navigation */
      doTest (e) {
        e.preventDefault()
        this.$emit('doTest')
        return false
      }
    }
    // Events
    /** Emits a custom event when the button in the component is clicked. The parent component can listen for this event and execute the the code to perform the test
    * @event doTest */
  }
</script>
